import React from "react";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import MessagesItemCommon from "./MessagesItemCommon/MessagesItemCommon";
import messages from "../../../locale/messages";
import defaultIcon from '/public/dashboard/defaultIconMenu.svg';
import bt from '../../../components/commonStyle.css';


const MessagesItem = ({ getAllThreadItems, loadMore }) => {

    return (
        <div className={bt.spaceTop4}>
            {
                getAllThreadItems?.threadItems != null && getAllThreadItems?.threadItems?.length > 0 && getAllThreadItems?.threadItems?.map((item, index) => (
                    <div key={index}>
                        <MessagesItemCommon
                            defaultIcon={defaultIcon}
                            text={item?.message}
                            userType={getAllThreadItems?.userDetails && (item?.authorId == getAllThreadItems?.userDetails?.id) ? 'user' : 'partnerDetails'}
                            userImage={(getAllThreadItems?.userDetails && item?.authorId == getAllThreadItems?.userDetails?.id) ? getAllThreadItems?.userDetails?.profile?.picture : getAllThreadItems?.partnerDetails && getAllThreadItems?.partnerDetails?.profile?.picture}
                            createdAt={item?.createdAt}
                        />
                    </div>
                ))
            }
            {
                getAllThreadItems?.threadItems != null && getAllThreadItems?.threadItems?.length > 0 && getAllThreadItems?.threadItems?.length < getAllThreadItems?.count && <div className={bt.loadMoreBtnContainer}>
                    <Button href="javascript:void(0)" onClick={() => loadMore()} className={cx(bt.btnPrimary, 'loaderButtonFlex')}><FormattedMessage {...messages.loadMoreMsg} /></Button>
                </div>
            }
        </div>
    )
}

export default withStyles(bt)(MessagesItem);
